import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { getPaddingClasses } from '../../utils/padding.js';
import { getSizingClassName, getSizingStyle } from '../../utils/sizing.js';
import { jsx } from 'react/jsx-runtime';
import Item from './Item/Item.js';

var styles = {
  "unit-base": "4",
  "list--legacy": "web_ui__List__list--legacy",
  "no-trailing-divider": "web_ui__List__no-trailing-divider",
  "tight": "web_ui__List__tight",
  "narrow": "web_ui__List__narrow",
  "default": "web_ui__List__default",
  "wide": "web_ui__List__wide",
  "inline": "web_ui__List__inline",
  "gap-none": "web_ui__List__gap-none",
  "gap-x-small": "web_ui__List__gap-x-small",
  "gap-small": "web_ui__List__gap-small",
  "gap-regular": "web_ui__List__gap-regular",
  "gap-medium": "web_ui__List__gap-medium",
  "gap-large": "web_ui__List__gap-large",
  "gap-larger": "web_ui__List__gap-larger",
  "gap-x-large": "web_ui__List__gap-x-large",
  "gap-x-larger": "web_ui__List__gap-x-larger",
  "gap-x2-large": "web_ui__List__gap-x2-large",
  "gap-x3-large": "web_ui__List__gap-x3-large",
  "gap-x4-large": "web_ui__List__gap-x4-large",
  "gap-x5-large": "web_ui__List__gap-x5-large",
  "gap-x6-large": "web_ui__List__gap-x6-large",
  "gap-space-0": "web_ui__List__gap-space-0",
  "gap-space-50": "web_ui__List__gap-space-50",
  "gap-space-100": "web_ui__List__gap-space-100",
  "gap-space-150": "web_ui__List__gap-space-150",
  "gap-space-200": "web_ui__List__gap-space-200",
  "gap-space-300": "web_ui__List__gap-space-300",
  "gap-space-400": "web_ui__List__gap-space-400",
  "gap-space-500": "web_ui__List__gap-space-500",
  "gap-space-600": "web_ui__List__gap-space-600",
  "gap-space-700": "web_ui__List__gap-space-700",
  "gap-space-900": "web_ui__List__gap-space-900",
  "gap-space-800": "web_ui__List__gap-space-800",
  "gap-space-1000": "web_ui__List__gap-space-1000",
  "gap-space-1100": "web_ui__List__gap-space-1100",
  "gap-space-1200": "web_ui__List__gap-space-1200",
  "gap-space-1400": "web_ui__List__gap-space-1400",
  "gap-space-1600": "web_ui__List__gap-space-1600",
  "gap-space-2400": "web_ui__List__gap-space-2400",
  "gap-space-3200": "web_ui__List__gap-space-3200",
  "list": "web_ui__List__list",
  "width-parent": "web_ui__List__width-parent",
  "width-content": "web_ui__List__width-content",
  "width-custom": "web_ui__List__width-custom",
  "height-parent": "web_ui__List__height-parent",
  "height-content": "web_ui__List__height-content",
  "height-custom": "web_ui__List__height-custom",
  "scroll": "web_ui__List__scroll",
  "direction-row": "web_ui__List__direction-row",
  "direction-column": "web_ui__List__direction-column",
  "divider-between": "web_ui__List__divider-between",
  "show-trailing-divider": "web_ui__List__show-trailing-divider",
  "show-leading-divider": "web_ui__List__show-leading-divider",
  "list--p-none": "web_ui__List__list--p-none",
  "list--pt-none": "web_ui__List__list--pt-none",
  "list--pr-none": "web_ui__List__list--pr-none",
  "list--pb-none": "web_ui__List__list--pb-none",
  "list--pl-none": "web_ui__List__list--pl-none",
  "list--px-none": "web_ui__List__list--px-none",
  "list--py-none": "web_ui__List__list--py-none",
  "list--p-x-small": "web_ui__List__list--p-x-small",
  "list--pt-x-small": "web_ui__List__list--pt-x-small",
  "list--pr-x-small": "web_ui__List__list--pr-x-small",
  "list--pb-x-small": "web_ui__List__list--pb-x-small",
  "list--pl-x-small": "web_ui__List__list--pl-x-small",
  "list--px-x-small": "web_ui__List__list--px-x-small",
  "list--py-x-small": "web_ui__List__list--py-x-small",
  "list--p-small": "web_ui__List__list--p-small",
  "list--pt-small": "web_ui__List__list--pt-small",
  "list--pr-small": "web_ui__List__list--pr-small",
  "list--pb-small": "web_ui__List__list--pb-small",
  "list--pl-small": "web_ui__List__list--pl-small",
  "list--px-small": "web_ui__List__list--px-small",
  "list--py-small": "web_ui__List__list--py-small",
  "list--p-regular": "web_ui__List__list--p-regular",
  "list--pt-regular": "web_ui__List__list--pt-regular",
  "list--pr-regular": "web_ui__List__list--pr-regular",
  "list--pb-regular": "web_ui__List__list--pb-regular",
  "list--pl-regular": "web_ui__List__list--pl-regular",
  "list--px-regular": "web_ui__List__list--px-regular",
  "list--py-regular": "web_ui__List__list--py-regular",
  "list--p-medium": "web_ui__List__list--p-medium",
  "list--pt-medium": "web_ui__List__list--pt-medium",
  "list--pr-medium": "web_ui__List__list--pr-medium",
  "list--pb-medium": "web_ui__List__list--pb-medium",
  "list--pl-medium": "web_ui__List__list--pl-medium",
  "list--px-medium": "web_ui__List__list--px-medium",
  "list--py-medium": "web_ui__List__list--py-medium",
  "list--p-large": "web_ui__List__list--p-large",
  "list--pt-large": "web_ui__List__list--pt-large",
  "list--pr-large": "web_ui__List__list--pr-large",
  "list--pb-large": "web_ui__List__list--pb-large",
  "list--pl-large": "web_ui__List__list--pl-large",
  "list--px-large": "web_ui__List__list--px-large",
  "list--py-large": "web_ui__List__list--py-large",
  "list--p-larger": "web_ui__List__list--p-larger",
  "list--pt-larger": "web_ui__List__list--pt-larger",
  "list--pr-larger": "web_ui__List__list--pr-larger",
  "list--pb-larger": "web_ui__List__list--pb-larger",
  "list--pl-larger": "web_ui__List__list--pl-larger",
  "list--px-larger": "web_ui__List__list--px-larger",
  "list--py-larger": "web_ui__List__list--py-larger",
  "list--p-x-large": "web_ui__List__list--p-x-large",
  "list--pt-x-large": "web_ui__List__list--pt-x-large",
  "list--pr-x-large": "web_ui__List__list--pr-x-large",
  "list--pb-x-large": "web_ui__List__list--pb-x-large",
  "list--pl-x-large": "web_ui__List__list--pl-x-large",
  "list--px-x-large": "web_ui__List__list--px-x-large",
  "list--py-x-large": "web_ui__List__list--py-x-large",
  "list--p-x-larger": "web_ui__List__list--p-x-larger",
  "list--pt-x-larger": "web_ui__List__list--pt-x-larger",
  "list--pr-x-larger": "web_ui__List__list--pr-x-larger",
  "list--pb-x-larger": "web_ui__List__list--pb-x-larger",
  "list--pl-x-larger": "web_ui__List__list--pl-x-larger",
  "list--px-x-larger": "web_ui__List__list--px-x-larger",
  "list--py-x-larger": "web_ui__List__list--py-x-larger",
  "list--p-x2-large": "web_ui__List__list--p-x2-large",
  "list--pt-x2-large": "web_ui__List__list--pt-x2-large",
  "list--pr-x2-large": "web_ui__List__list--pr-x2-large",
  "list--pb-x2-large": "web_ui__List__list--pb-x2-large",
  "list--pl-x2-large": "web_ui__List__list--pl-x2-large",
  "list--px-x2-large": "web_ui__List__list--px-x2-large",
  "list--py-x2-large": "web_ui__List__list--py-x2-large",
  "list--p-x3-large": "web_ui__List__list--p-x3-large",
  "list--pt-x3-large": "web_ui__List__list--pt-x3-large",
  "list--pr-x3-large": "web_ui__List__list--pr-x3-large",
  "list--pb-x3-large": "web_ui__List__list--pb-x3-large",
  "list--pl-x3-large": "web_ui__List__list--pl-x3-large",
  "list--px-x3-large": "web_ui__List__list--px-x3-large",
  "list--py-x3-large": "web_ui__List__list--py-x3-large",
  "list--p-x4-large": "web_ui__List__list--p-x4-large",
  "list--pt-x4-large": "web_ui__List__list--pt-x4-large",
  "list--pr-x4-large": "web_ui__List__list--pr-x4-large",
  "list--pb-x4-large": "web_ui__List__list--pb-x4-large",
  "list--pl-x4-large": "web_ui__List__list--pl-x4-large",
  "list--px-x4-large": "web_ui__List__list--px-x4-large",
  "list--py-x4-large": "web_ui__List__list--py-x4-large",
  "list--p-x5-large": "web_ui__List__list--p-x5-large",
  "list--pt-x5-large": "web_ui__List__list--pt-x5-large",
  "list--pr-x5-large": "web_ui__List__list--pr-x5-large",
  "list--pb-x5-large": "web_ui__List__list--pb-x5-large",
  "list--pl-x5-large": "web_ui__List__list--pl-x5-large",
  "list--px-x5-large": "web_ui__List__list--px-x5-large",
  "list--py-x5-large": "web_ui__List__list--py-x5-large",
  "list--p-x6-large": "web_ui__List__list--p-x6-large",
  "list--pt-x6-large": "web_ui__List__list--pt-x6-large",
  "list--pr-x6-large": "web_ui__List__list--pr-x6-large",
  "list--pb-x6-large": "web_ui__List__list--pb-x6-large",
  "list--pl-x6-large": "web_ui__List__list--pl-x6-large",
  "list--px-x6-large": "web_ui__List__list--px-x6-large",
  "list--py-x6-large": "web_ui__List__list--py-x6-large",
  "list--p-space-0": "web_ui__List__list--p-space-0",
  "list--pt-space-0": "web_ui__List__list--pt-space-0",
  "list--pr-space-0": "web_ui__List__list--pr-space-0",
  "list--pb-space-0": "web_ui__List__list--pb-space-0",
  "list--pl-space-0": "web_ui__List__list--pl-space-0",
  "list--px-space-0": "web_ui__List__list--px-space-0",
  "list--py-space-0": "web_ui__List__list--py-space-0",
  "list--p-space-50": "web_ui__List__list--p-space-50",
  "list--pt-space-50": "web_ui__List__list--pt-space-50",
  "list--pr-space-50": "web_ui__List__list--pr-space-50",
  "list--pb-space-50": "web_ui__List__list--pb-space-50",
  "list--pl-space-50": "web_ui__List__list--pl-space-50",
  "list--px-space-50": "web_ui__List__list--px-space-50",
  "list--py-space-50": "web_ui__List__list--py-space-50",
  "list--p-space-100": "web_ui__List__list--p-space-100",
  "list--pt-space-100": "web_ui__List__list--pt-space-100",
  "list--pr-space-100": "web_ui__List__list--pr-space-100",
  "list--pb-space-100": "web_ui__List__list--pb-space-100",
  "list--pl-space-100": "web_ui__List__list--pl-space-100",
  "list--px-space-100": "web_ui__List__list--px-space-100",
  "list--py-space-100": "web_ui__List__list--py-space-100",
  "list--p-space-150": "web_ui__List__list--p-space-150",
  "list--pt-space-150": "web_ui__List__list--pt-space-150",
  "list--pr-space-150": "web_ui__List__list--pr-space-150",
  "list--pb-space-150": "web_ui__List__list--pb-space-150",
  "list--pl-space-150": "web_ui__List__list--pl-space-150",
  "list--px-space-150": "web_ui__List__list--px-space-150",
  "list--py-space-150": "web_ui__List__list--py-space-150",
  "list--p-space-200": "web_ui__List__list--p-space-200",
  "list--pt-space-200": "web_ui__List__list--pt-space-200",
  "list--pr-space-200": "web_ui__List__list--pr-space-200",
  "list--pb-space-200": "web_ui__List__list--pb-space-200",
  "list--pl-space-200": "web_ui__List__list--pl-space-200",
  "list--px-space-200": "web_ui__List__list--px-space-200",
  "list--py-space-200": "web_ui__List__list--py-space-200",
  "list--p-space-300": "web_ui__List__list--p-space-300",
  "list--pt-space-300": "web_ui__List__list--pt-space-300",
  "list--pr-space-300": "web_ui__List__list--pr-space-300",
  "list--pb-space-300": "web_ui__List__list--pb-space-300",
  "list--pl-space-300": "web_ui__List__list--pl-space-300",
  "list--px-space-300": "web_ui__List__list--px-space-300",
  "list--py-space-300": "web_ui__List__list--py-space-300",
  "list--p-space-400": "web_ui__List__list--p-space-400",
  "list--pt-space-400": "web_ui__List__list--pt-space-400",
  "list--pr-space-400": "web_ui__List__list--pr-space-400",
  "list--pb-space-400": "web_ui__List__list--pb-space-400",
  "list--pl-space-400": "web_ui__List__list--pl-space-400",
  "list--px-space-400": "web_ui__List__list--px-space-400",
  "list--py-space-400": "web_ui__List__list--py-space-400",
  "list--p-space-500": "web_ui__List__list--p-space-500",
  "list--pt-space-500": "web_ui__List__list--pt-space-500",
  "list--pr-space-500": "web_ui__List__list--pr-space-500",
  "list--pb-space-500": "web_ui__List__list--pb-space-500",
  "list--pl-space-500": "web_ui__List__list--pl-space-500",
  "list--px-space-500": "web_ui__List__list--px-space-500",
  "list--py-space-500": "web_ui__List__list--py-space-500",
  "list--p-space-600": "web_ui__List__list--p-space-600",
  "list--pt-space-600": "web_ui__List__list--pt-space-600",
  "list--pr-space-600": "web_ui__List__list--pr-space-600",
  "list--pb-space-600": "web_ui__List__list--pb-space-600",
  "list--pl-space-600": "web_ui__List__list--pl-space-600",
  "list--px-space-600": "web_ui__List__list--px-space-600",
  "list--py-space-600": "web_ui__List__list--py-space-600",
  "list--p-space-700": "web_ui__List__list--p-space-700",
  "list--pt-space-700": "web_ui__List__list--pt-space-700",
  "list--pr-space-700": "web_ui__List__list--pr-space-700",
  "list--pb-space-700": "web_ui__List__list--pb-space-700",
  "list--pl-space-700": "web_ui__List__list--pl-space-700",
  "list--px-space-700": "web_ui__List__list--px-space-700",
  "list--py-space-700": "web_ui__List__list--py-space-700",
  "list--p-space-900": "web_ui__List__list--p-space-900",
  "list--pt-space-900": "web_ui__List__list--pt-space-900",
  "list--pr-space-900": "web_ui__List__list--pr-space-900",
  "list--pb-space-900": "web_ui__List__list--pb-space-900",
  "list--pl-space-900": "web_ui__List__list--pl-space-900",
  "list--px-space-900": "web_ui__List__list--px-space-900",
  "list--py-space-900": "web_ui__List__list--py-space-900",
  "list--p-space-800": "web_ui__List__list--p-space-800",
  "list--pt-space-800": "web_ui__List__list--pt-space-800",
  "list--pr-space-800": "web_ui__List__list--pr-space-800",
  "list--pb-space-800": "web_ui__List__list--pb-space-800",
  "list--pl-space-800": "web_ui__List__list--pl-space-800",
  "list--px-space-800": "web_ui__List__list--px-space-800",
  "list--py-space-800": "web_ui__List__list--py-space-800",
  "list--p-space-1000": "web_ui__List__list--p-space-1000",
  "list--pt-space-1000": "web_ui__List__list--pt-space-1000",
  "list--pr-space-1000": "web_ui__List__list--pr-space-1000",
  "list--pb-space-1000": "web_ui__List__list--pb-space-1000",
  "list--pl-space-1000": "web_ui__List__list--pl-space-1000",
  "list--px-space-1000": "web_ui__List__list--px-space-1000",
  "list--py-space-1000": "web_ui__List__list--py-space-1000",
  "list--p-space-1100": "web_ui__List__list--p-space-1100",
  "list--pt-space-1100": "web_ui__List__list--pt-space-1100",
  "list--pr-space-1100": "web_ui__List__list--pr-space-1100",
  "list--pb-space-1100": "web_ui__List__list--pb-space-1100",
  "list--pl-space-1100": "web_ui__List__list--pl-space-1100",
  "list--px-space-1100": "web_ui__List__list--px-space-1100",
  "list--py-space-1100": "web_ui__List__list--py-space-1100",
  "list--p-space-1200": "web_ui__List__list--p-space-1200",
  "list--pt-space-1200": "web_ui__List__list--pt-space-1200",
  "list--pr-space-1200": "web_ui__List__list--pr-space-1200",
  "list--pb-space-1200": "web_ui__List__list--pb-space-1200",
  "list--pl-space-1200": "web_ui__List__list--pl-space-1200",
  "list--px-space-1200": "web_ui__List__list--px-space-1200",
  "list--py-space-1200": "web_ui__List__list--py-space-1200",
  "list--p-space-1400": "web_ui__List__list--p-space-1400",
  "list--pt-space-1400": "web_ui__List__list--pt-space-1400",
  "list--pr-space-1400": "web_ui__List__list--pr-space-1400",
  "list--pb-space-1400": "web_ui__List__list--pb-space-1400",
  "list--pl-space-1400": "web_ui__List__list--pl-space-1400",
  "list--px-space-1400": "web_ui__List__list--px-space-1400",
  "list--py-space-1400": "web_ui__List__list--py-space-1400",
  "list--p-space-1600": "web_ui__List__list--p-space-1600",
  "list--pt-space-1600": "web_ui__List__list--pt-space-1600",
  "list--pr-space-1600": "web_ui__List__list--pr-space-1600",
  "list--pb-space-1600": "web_ui__List__list--pb-space-1600",
  "list--pl-space-1600": "web_ui__List__list--pl-space-1600",
  "list--px-space-1600": "web_ui__List__list--px-space-1600",
  "list--py-space-1600": "web_ui__List__list--py-space-1600",
  "list--p-space-2400": "web_ui__List__list--p-space-2400",
  "list--pt-space-2400": "web_ui__List__list--pt-space-2400",
  "list--pr-space-2400": "web_ui__List__list--pr-space-2400",
  "list--pb-space-2400": "web_ui__List__list--pb-space-2400",
  "list--pl-space-2400": "web_ui__List__list--pl-space-2400",
  "list--px-space-2400": "web_ui__List__list--px-space-2400",
  "list--py-space-2400": "web_ui__List__list--py-space-2400",
  "list--p-space-3200": "web_ui__List__list--p-space-3200",
  "list--pt-space-3200": "web_ui__List__list--pt-space-3200",
  "list--pr-space-3200": "web_ui__List__list--pr-space-3200",
  "list--pb-space-3200": "web_ui__List__list--pb-space-3200",
  "list--pl-space-3200": "web_ui__List__list--pl-space-3200",
  "list--px-space-3200": "web_ui__List__list--px-space-3200",
  "list--py-space-3200": "web_ui__List__list--py-space-3200"
};

var LIST_SIZE_VALUES = ['default', 'tight', 'narrow', 'wide'];
/* ---------- Back-compat shim (deprecated) ---------- */
var LIST_SIZE = {
  Default: 'default',
  Tight: 'tight',
  Narrow: 'narrow',
  Wide: 'wide'
};
var ListBase = function ListBase(_ref) {
  var padding = _ref.padding,
    paddingTop = _ref.paddingTop,
    paddingRight = _ref.paddingRight,
    paddingBottom = _ref.paddingBottom,
    paddingLeft = _ref.paddingLeft,
    paddingHorizontal = _ref.paddingHorizontal,
    paddingVertical = _ref.paddingVertical,
    _ref$gapSize = _ref.gapSize,
    gapSize = _ref$gapSize === void 0 ? 'regular' : _ref$gapSize,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'parent' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 'parent' : _ref$height,
    direction = _ref.direction,
    _ref$scroll = _ref.scroll,
    scroll = _ref$scroll === void 0 ? false : _ref$scroll,
    _ref$showStartDivider = _ref.showStartDivider,
    showStartDivider = _ref$showStartDivider === void 0 ? false : _ref$showStartDivider,
    _ref$showEndDivider = _ref.showEndDivider,
    showEndDivider = _ref$showEndDivider === void 0 ? false : _ref$showEndDivider,
    _ref$dividerBetween = _ref.dividerBetween,
    dividerBetween = _ref$dividerBetween === void 0 ? false : _ref$dividerBetween,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$noTrailingDivide = _ref.noTrailingDivider,
    noTrailingDivider = _ref$noTrailingDivide === void 0 ? false : _ref$noTrailingDivide,
    children = _ref.children,
    testId = _ref.testId,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'legacy' : _ref$mode;
  var css = classNames.bind(styles);
  var isModern = mode === 'modern';

  // Dev-only guidance for mixed usage
  if (process.env.NODE_ENV !== 'production') {
    if (!isModern) {
      var usedNewProps = padding !== undefined || paddingTop !== undefined || paddingRight !== undefined || paddingBottom !== undefined || paddingLeft !== undefined || paddingHorizontal !== undefined || paddingVertical !== undefined || gapSize !== 'regular' || width !== 'parent' || height !== 'parent' || direction !== undefined || scroll !== false || showStartDivider !== false || showEndDivider !== false || dividerBetween !== false;
      if (usedNewProps) {
        // eslint-disable-next-line no-console
        console.warn('[List] New API props are ignored in legacy mode. Use `mode="modern"` to enable them.');
      }
    } else if (size !== 'default' || inline !== false || noTrailingDivider !== false) {
      // eslint-disable-next-line no-console
      console.warn('[List] Legacy props (`size`, `inline`, `noTrailingDivider`) are ignored in modern mode.');
    }
  }

  // Modern-only computations
  var sizingClass = isModern ? getSizingClassName(styles, width, height) : '';
  var style = isModern ? getSizingStyle('list', width, height) : undefined;
  var paddingClass = isModern ? getPaddingClasses(styles, 'list', {
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingX: paddingHorizontal,
    paddingY: paddingVertical
  }) : '';
  var gapClass = isModern ? styles["gap-".concat(gapSize)] : '';
  var computedDirection = isModern ? direction : undefined;
  var listClass = css(paddingClass, sizingClass, gapClass, styles.list, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles['show-trailing-divider'], isModern && showEndDivider), styles['show-leading-divider'], isModern && showStartDivider), styles['direction-row'], isModern && computedDirection === 'horizontal'), styles['direction-column'], isModern && computedDirection !== 'horizontal'), styles['divider-between'], isModern && dividerBetween), styles.scroll, isModern && scroll), styles['list--legacy'], !isModern), styles.inline, !isModern && inline), styles['no-trailing-divider'], !isModern && noTrailingDivider));
  var sizeClass = isModern ? undefined : size;
  return /*#__PURE__*/jsx("ul", {
    className: css(listClass, sizeClass),
    "data-testid": testId,
    style: style,
    children: children
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var List = _Object$assign(ListBase, {
  /**
   * @deprecated Use string literals instead: 'default' | 'tight' | 'narrow' | 'wide'
   */
  Size: LIST_SIZE,
  Item: Item
});

export { LIST_SIZE, LIST_SIZE_VALUES, List, List as default };
//# sourceMappingURL=List.js.map
